import { Button, Flex } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import useFormatter from 'src/customHooks/useFormatter';


export interface LicenseSystemDetailsInModal {
    appServiceVersion: string | undefined;
    updateNumber: string | undefined;
    installedUpdateNumber: string | undefined;
    lastSeenDate: string | undefined;
    addedBy: string;
    colorProofGoUsers: string[];
    colorCardUsers: string[];
}

export interface LicenseSystemInfoModalProps {
    onClose?: () => void;
    licenseSystemDetails: LicenseSystemDetailsInModal;
};

const LicenseSystemInfoModal: FunctionComponent<LicenseSystemInfoModalProps> = (props) => {
    const { t } = useTranslation();
    const { formatDate, formatTime } = useFormatter();

    return (
        <Flex width='100%'>
            <Flex ml="10px" flexDirection="column" width='100%' gap='16px'>
                <Flex gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.app_service_version_title', 'Application Service version')}
                    </span>
                    <span className="px12_400_normal" aria-label='app-service-version'>
                        {props.licenseSystemDetails.appServiceVersion ?? 'Unknown'}
                    </span>
                </Flex>
                <Flex gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.available_license_update_title', 'Available license update')}
                    </span>
                    <span className="px12_400_normal" aria-label='available-license-update-number'>
                        {props.licenseSystemDetails.updateNumber ?? 'Unknown'}
                    </span>
                </Flex>
                <Flex gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.installed_license_update_title', 'Installed license update')}
                    </span>
                    <span className="px12_400_normal" aria-label='installed-license-update-number'>
                        {props.licenseSystemDetails.installedUpdateNumber ?? 'Unknown'}
                    </span>
                </Flex>
                <Flex gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.last_seen_title', 'Last seen')}
                    </span>
                    <span className="px12_400_normal" aria-label='last-seen-date'>
                        {`${formatDate(props.licenseSystemDetails.lastSeenDate)} - ${formatTime(props.licenseSystemDetails.lastSeenDate)}`}
                    </span>
                </Flex>
                <Flex gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.added_by_title', 'Added by')}
                    </span>
                    <span className="px12_400_normal" aria-label="user-email">
                        {props.licenseSystemDetails.addedBy}
                    </span>
                </Flex>

                <Flex aria-label="ColorProofGO users list" gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.cpgo_users_title', 'ColorProof GO users')}
                    </span>
                    {props.licenseSystemDetails.colorProofGoUsers.length > 0
                        ? props.licenseSystemDetails.colorProofGoUsers.map(email => <span className="px12_400_normal" key={email}>{email}</span>)
                        : '-'
                    }
                </Flex>
                <Flex aria-label="ColorCard users list" gap='4px' flexDirection="column">
                    <span className="px12_400_weak">
                        {t('LicenseSystemInfoModal.colorCard_users_title', 'ColorCard users')}
                    </span>
                    {props.licenseSystemDetails.colorCardUsers.length > 0
                        ? props.licenseSystemDetails.colorCardUsers.map(email => <span className="px12_400_normal" key={email}>{email}</span>)
                        : '-'
                    }
                </Flex>

                <Flex justifyContent="flex-end" pr='8px'>
                    <Button
                        variant="primary"
                        type="button"
                        onClick={() => props.onClose?.()}
                    >
                        {t('ButtonTitles.action_close_btn', 'Close')}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default LicenseSystemInfoModal;